import styled from "styled-components";
import {SwiperComponent} from "../../../../../swiper/swiper.component";

export const VideoSlidesArenaSwiperComponentBox = styled(SwiperComponent)`
    width: 100%;
    height:100%;
`